import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import HomePage from "./pages/HomePage";
import BlogDetailPage from "./pages/BlogDetailPage";
import BlogPage from "./pages/BlogPage";
import CaseStudyDetailPage from "./pages/CaseStudyDetailPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import AboutUsPage from "./pages/AboutUsPage";
import NewsletterPage from "./pages/NewsletterPage";
import NewsletterDetailPage from "./pages/NewsletterDetailPage";
import AdminBlogPage from "./pages/AdminBlogPage";
import AdminCaseStudiesPage from "./pages/AdminCaseStudiesPage";
import AdminNewsletterPage from "./pages/AdminNewsletterPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import ContactPage from "./pages/ContactPage";
import FloatingContact from "./components/FloatingContact";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/case-studies/:slug" element={<CaseStudyDetailPage />} />
          <Route path="/newsletter" element={<NewsletterPage />} />
          <Route path="/newsletter/:slug" element={<NewsletterDetailPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/blog" element={<AdminBlogPage />} />
          <Route
            path="/admin/case-studies"
            element={<AdminCaseStudiesPage />}
          />
          <Route path="/admin/newsletter" element={<AdminNewsletterPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <FloatingContact />
      </BrowserRouter>
    </div>
  );
}

export default App;
